export const breadthFirstSearch = (graph, start, degree = null, iterator) => {
    // Initialize the queue for BFS and a set to track visited nodes
    const queue = [
        { node: start, level: 0 },
    ];
    const visited = new Set();
    // Mark the start node as visited
    visited.add(start);
    // Loop until there are no more nodes in the queue
    while (queue.length > 0) {
        const { node, level } = queue.shift(); // Dequeue the next node
        // Add the node to the result list
        iterator(node); // Call the iterator function with the current node
        // Stop if the degree limit is specified and reached
        if (degree !== null && level >= degree) {
            continue;
        }
        // Iterate over the neighbors of the current node
        for (const neighbor of graph[node] || []) {
            // If the neighbor hasn't been visited, add it to the queue
            if (!visited.has(neighbor)) {
                visited.add(neighbor);
                queue.push({ node: neighbor, level: level + 1 }); // Enqueue with incremented level
            }
        }
    }
};
